<script>
    import { clickOutside } from "../utils/clickOutside.js";

    export let items = [];
    let isOpen = false;
    
</script>

<div
    class="dropdown"
    use:clickOutside
    on:click_outside={() => (isOpen = false)}
>
    <button class="dropdown-toggle" on:click={() => (isOpen = !isOpen)}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            ><path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
            ></path></svg
        >
    </button>
    {#if isOpen}
        <div class="dropdown-menu">
            {#each items as item}
                {#if item.hide !== true}
                    <button
                        class="dropdown-item {item.className ?? ''}"
                        on:click|stopPropagation={() => {
                            item.action();
                            isOpen = false;
                        }}>{item.label}</button
                    >
                {/if}
            {/each}
        </div>
    {/if}
</div>

<style>
    @import "../main.css";

    .dropdown {
        @apply reset relative flex text-left !important;
    }

    .dropdown::before {
        @apply hidden !important;
    }

    .dropdown-toggle {
        @apply reset inline-flex h-4 w-4 min-w-fit items-center justify-center bg-transparent text-sm font-medium focus:outline-none !important;
    }

    .dropdown-toggle svg {
        @apply reset h-4 w-4 text-gray-400 hover:text-gray-700 !important;
    }

    .dropdown-menu {
        @apply reset absolute right-0 top-0 z-50 flex flex-col rounded-md border border-solid border-gray-200 bg-white p-1 !important;
    }

    .dropdown-item {
        @apply reset flex cursor-pointer items-center justify-start whitespace-nowrap rounded px-2 py-1 text-xs hover:bg-gray-200 !important;
    }
</style>
